export const OCC_METRIC_TOOLTIPS: Record<string, string> = {
  pct: 'Base occupancy adjustment percentage',

  minStayExpectedNTS: 'Minimum stay expected (NTS)',

  shortTermGapMultiplierPCT: 'Short-term gap multiplier (%)',
  shortTermGapMinNumNightsRevNTS: 'Short-term gap min nights revenue (%)',

  longTermGapMultiplierPCT: 'Long-term gap multiplier (%)',
  longTermGapEmptyMultiplierPCT: 'Long-term gap empty multiplier (%)',

  connectingFrontOrBackMultiplierPCT:
    'Connecting front or back multiplier (%)',

  connectingFrontAndBackMultiplierPCT:
    'Connecting front AND back multiplier (%)'
};
